export const DISMISSED_AT_PREFIX = 'store-refresh-dismissed-at:';
export const SHOWING_STALE_MILLISECONDS = 30_000;
